module.exports = __webpack_public_path__ + "img/5Bab.80817e28.jpeg";